import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  custom: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    userSelect: 'none',
    transform: 'translate(-50%, -50%)',
  },
  markerOutline: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
    zIndex: 1,
    pointerEvents: 'none',
  },
  markerOutlineOuter: {
    transition: 'all 0.2s ease-in',
    boxShadow: '0px 0px 6px 1px green',
    // border: "2px solid green",
    // backgroundColor: "rgba(0,255,0,0.2)"
  },
}));

const CircleMarker = (props) => {
  const classes = useStyles();
  const { radius } = props;
  return (
    <div className={classes.custom}>
      <div
        className={classes.markerOutline + ' ' + classes.markerOutlineOuter}
        style={{ width: radius * 2 + 'px', height: radius * 2 + 'px' }}
      ></div>
    </div>
  );
};

export default CircleMarker;
